import React from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { FaPhone, FaArrowLeft, FaArrowRight } from 'react-icons/fa';

const ContactForm = ({ isActive, formData, handleChange, handlePrev, handleNext }) => {
    return (
        <div id="iletisim-form" className={isActive ? 'd-block' : 'd-none'}>
            <h4 className="form-section-title">
                <FaPhone className="me-2" /> İletişim Bilgileri
            </h4>

            <Row className="mb-4">
                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Telefon</Form.Label>
                        <Form.Control
                            required
                            type="tel"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            placeholder="0500 000 00 00"
                            className="py-3"
                        />
                        <Form.Control.Feedback type="invalid">
                            Lütfen telefon numaranızı girin
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>E-posta</Form.Label>
                        <Form.Control
                            required
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="ornek@email.com"
                            className="py-3"
                        />
                        <Form.Control.Feedback type="invalid">
                            Lütfen geçerli bir e-posta adresi girin
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>

                <Col md={12}>
                    <Form.Group className="mb-3">
                        <Form.Label>Adres</Form.Label>
                        <Form.Control
                            required
                            as="textarea"
                            rows={3}
                            name="address"
                            value={formData.address}
                            onChange={handleChange}
                            placeholder="Tam adresiniz"
                        />
                        <Form.Control.Feedback type="invalid">
                            Lütfen adresinizi girin
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>

                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>İl</Form.Label>
                        <Form.Control
                            required
                            type="text"
                            name="city"
                            value={formData.city}
                            onChange={handleChange}
                            placeholder="İl adını yazın (örn: İstanbul)"
                            className="py-3"
                        />
                        <Form.Control.Feedback type="invalid">
                            Lütfen il adını girin
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>İlçe</Form.Label>
                        <Form.Control
                            required
                            type="text"
                            name="district"
                            value={formData.district}
                            onChange={handleChange}
                            placeholder="İlçe adını yazın (örn: Kadıköy)"
                            className="py-3"
                        />
                        <Form.Control.Feedback type="invalid">
                            Lütfen ilçe adını girin
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>

            <div className="d-flex justify-content-between">
                <Button
                    variant="outline-secondary"
                    onClick={handlePrev}
                    className="d-flex align-items-center px-4 py-2"
                >
                    <FaArrowLeft className="me-2" />
                    Geri Dön
                </Button>
                <Button
                    onClick={handleNext}
                    className="apply-btn-black d-flex align-items-center px-4 py-2"
                >
                    Devam Et
                    <FaArrowRight className="ms-2" />
                </Button>
            </div>
        </div>
    );
};

export default ContactForm;